import { render, staticRenderFns } from "./Navbardatabase.vue?vue&type=template&id=ae1248de&"
import script from "./Navbardatabase.vue?vue&type=script&lang=js&"
export * from "./Navbardatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports